import { useRef, useState } from "react";
// import videoFile from "../../../Assets/Images/home/home-video.mp4";
import PlayIcon from "../../../Assets/Images/home/play-icon.png";
import thumb from "../../../Assets/Images/home/WElcometo.png";
import { BsFillPlayCircleFill, BsFillPauseCircleFill  } from "react-icons/bs";
import "./missionstatement.css"

const MissionStatement = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="home-mission-container">
      <div className="home-mission-card" style={{border: "none"}}>
        <div className="home-mission-right">
          <div className="video-container">
            <video
              ref={videoRef}
              src="https://shootin-frontend.s3.us-east-1.amazonaws.com/Welcome+Video.mp4"
              poster={thumb}
              className="w-full"
              controls
              playsInline

              onEnded={handleVideoEnd}
            />
            <div className="video-controls">
              {!isPlaying && (
                <button onClick={togglePlay} className="video-play-btn">
                  <img src={PlayIcon} alt="play" width={80} />
                </button>
              )}
            </div>
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionStatement;
